import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverCloseButton,
  Button,
  useDisclosure,
} from '@chakra-ui/react';

import { useQueryParams } from '@/hooks/use-query-params';
import { useEffect } from 'react';
import { useTimeout } from 'ahooks';

export const PostInstallPin = () => {
  const queryParams = useQueryParams();
  const { onClose, isOpen, onOpen } = useDisclosure();

  useTimeout(() => {
    onClose();
  }, 10000);

  useEffect(() => {
    const extSuccess = queryParams?.get('extSuccess');
    if (extSuccess === 'true') {
      onOpen();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (queryParams?.get('extSuccess') !== 'true') {
    return null;
  }

  return (
    <Popover isOpen={isOpen}>
      <PopoverTrigger>
        <Button h="0" visibility="hidden" />
      </PopoverTrigger>
      <PopoverContent bg="#161616" p="12px" top="-40px">
        <PopoverCloseButton color="#FFF" onClick={onClose} />
        <PopoverHeader
          color="#FFF"
          fontSize="16px"
          fontWeight="semiBold"
          borderBottom="0"
        >
          Put a pin on the Kula extension.
        </PopoverHeader>
        <PopoverBody color="#FFF" fontSize="14px" fontWeight="medium">
          Having the extension handy will save you seconds per candidate, and
          hours in the long run.
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
